"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheatsAction = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@dp-instant/core");
var inversify_1 = require("inversify");
var CheatsAction = (function (_super) {
    tslib_1.__extends(CheatsAction, _super);
    function CheatsAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheatsAction.prototype.execute = function (cheats) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var canvas, _a, cheat1, cheat2, cheat3;
            return tslib_1.__generator(this, function (_b) {
                canvas = document.getElementById(core_1.CANVAS_ID);
                _a = tslib_1.__read(cheats, 3), cheat1 = _a[0], cheat2 = _a[1], cheat3 = _a[2];
                cheat2 || (cheat2 = cheat1);
                cheat3 || (cheat3 = cheat2 || cheat1);
                if (canvas) {
                    document.addEventListener("touchstart", function (e) {
                        var _a;
                        switch ((_a = e === null || e === void 0 ? void 0 : e.touches) === null || _a === void 0 ? void 0 : _a.length) {
                            case 2:
                                cheat1();
                                break;
                            case 3:
                                cheat2();
                                break;
                            case 4:
                                cheat3();
                                break;
                        }
                    });
                    canvas.addEventListener("pointerdown", function (e) {
                        if (e.shiftKey && e.altKey) {
                            return cheat3();
                        }
                        if (e.altKey) {
                            return cheat2();
                        }
                        if (e.shiftKey) {
                            return cheat1();
                        }
                    });
                }
                return [2];
            });
        });
    };
    CheatsAction = tslib_1.__decorate([
        (0, inversify_1.injectable)()
    ], CheatsAction);
    return CheatsAction;
}(core_1.Action));
exports.CheatsAction = CheatsAction;
//# sourceMappingURL=CheatsAction.js.map